import React from 'react';
import styles from './TextInput.module.scss';
export const TextInput = ({ ref, ...props })=>/*#__PURE__*/ React.createElement("input", {
        ref: ref,
        className: styles.textInput,
        "data-testid": "text-input",
        ...props
    });
